import classNames from 'classnames'
import ChevronDownIcon from 'mdi-react/ChevronDownIcon'
import CloseIcon from 'mdi-react/CloseIcon'
import React from 'react'

import { Chip, CircularProgress, IconButton, MenuItem, Paper, TextField, Typography } from '@mui/material'

function NoOptionsMessage(props: any) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.optionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function inputComponent({ inputRef, ...props }: any) {
  return <div ref={inputRef} {...props} />
}

function Control(props: any) {
  return (
    <TextField
      fullWidth
      variant="standard"
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  )
}

function Option(props: any) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      className={props.selectProps.classes.menuOption}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  )
}

function Placeholder(props: any) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function SingleValue(props: any) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function ValueContainer(props: any) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>
}

function MultiValue(props: any) {
  const { isValid } = props.data
  return (
    <Chip
      color="primary"
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
        [props.selectProps.classes.disabledChip]: isValid === false,
      })}
      onDelete={props.removeProps.onClick}
    />
  )
}

function Menu(props: any) {
  return (
    <Paper elevation={2} square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

function LoadingMessage(props: any) {
  return (
    <Typography className={props.selectProps.classes.optionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function ClearIndicator({ selectProps: { classes }, innerProps: { ref, ...restInnerProps } }: any) {
  return (
    <IconButton {...restInnerProps} className={classes.iconButton}>
      <CloseIcon size={20} />
    </IconButton>
  )
}

function DropdownIndicator({ selectProps: { classes } }: any) {
  return (
    <IconButton className={classes.iconButton}>
      <ChevronDownIcon size={20} />
    </IconButton>
  )
}

function LoadingIndicator({ selectProps: { classes } }: any) {
  return <CircularProgress size={18} thickness={5} className={classes.loading} />
}

function IndicatorSeparator({ selectProps: { classes } }: any) {
  return <span className={classes.indicatorSeparator} />
}

const selectComponents = (isLoading: boolean) => ({
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
  ClearIndicator,
  DropdownIndicator: isLoading ? LoadingIndicator : DropdownIndicator,
  LoadingIndicator,
  LoadingMessage,
  IndicatorSeparator,
})

export { selectComponents }
